<div class="card-body" style="display: block">
  <div class="row">
    <div class="col-md-12">
      <a  class= " cur pull-right " (click)="close()"><i style="float: right;" class="fa fa-window-close text-red pos" title="Fermer" aria-hidden="true"></i></a>
      <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
            <label for="name">Siren </label>
            <input [readonly]="commercial"type="text"  id='siren' class="form-control" [value]="user.siren" disabled/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
            <label for="name">Siret </label>
            <input [readonly]="commercial"type="text"  id='siret' class="form-control" [value]="user.siret" disabled/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="name">Nom annonceur </label>
              <input [readonly]="commercial"type="text"  id='name' class="form-control" formControlName="name" />
              <div *ngIf="this.registerForm.get('name').touched && f.name.errors" class="invalid-feedback">
                <div  class="err" *ngIf="f.name.errors.required">*Société requise.</div>
                <div class="err" *ngIf="f.name.errors.maxlength || f.name.errors.minlength">*Société doit contenir entre 3 et 50 caractères</div>
                <div class="err" *ngIf="f.name.errors.pattern">*Les alphabets uniquement  (pas de caractères spéciaux sauf - et ' ) </div>
              </div>
            </div>
            </div>
          </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
            <label for="companyName">Raison sociale</label><br>
            <input type="text"  id='companyName' formControlName="companyName" class="form-control"
                   [ngClass]="{ 'is-invalid': submitted && f.companyName.errors }" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
            <label for="address1">Adresse1 </label><br>
            <input type="text"  id='address1' formControlName="address1" class="form-control"
                   [ngClass]="{ 'is-invalid': submitted && f.address1.errors }" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
            <label for="address2">Adresse2 </label><br>
            <input type="text"  id='address2' formControlName="address2" class="form-control"
                   [ngClass]="{ 'is-invalid': submitted && f.address2.errors }" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
            <label for="postalCode">Code postal </label><br>
            <input type="text"  id='postalCode' formControlName="postalCode" class="form-control"
                   [ngClass]="{ 'is-invalid': submitted && f.postalCode.errors }" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
            <label for="city">Ville </label><br>
            <input type="text"  id='city' formControlName="city" class="form-control"
                   [ngClass]="{ 'is-invalid': submitted && f.city.errors }" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
            <label for="country">Pays </label><br>
            <input type="text"  id='country' formControlName="country" class="form-control"
                   [ngClass]="{ 'is-invalid': submitted && f.country.errors }" />
            </div>
          </div>
        </div>
        <!-- Image Preview -->
        <div class="form-group">
          <div class="preview" *ngIf="preview">
            <img class= "imageClient" [src]="preview" [alt]="registerForm.value.name">
          </div>
        </div>

        <!-- File Input -->
        <div class="form-group">
          <input type="file" (change)="uploadFile($event)">Télécharger logo
        </div>


        <div *ngIf="user.autorisationStatus!='Interne' && (type=== userType.AGENT_COMMERCIAL_SUPPORT1 || type=== userType.AGENT_COMMERCIAL_SUPPORT2)" class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Certification statut</label>
              <select  class="form-control  select2 select2-hidden-accessible" style="width: 100%;"
                       formControlName="statut" >
                <option value="" disabled selected>choisissez le statut</option>
                <option  [value]= clientAutorisationStatus.CERTIFIED>Certifié </option>
                <option  [value]= clientAutorisationStatus.NOTCERTIFIED>Non certifié </option>
                <option  [value]= clientAutorisationStatus.REVOKED>Révoqué</option>
              </select>
              <div *ngIf="this.registerForm.get('statut').touched && f.statut.errors" class="invalid-feedback">
                <div  class="err" *ngIf="f.statut.errors.required">*Statut requis</div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="form-group">
              <label for="Niveau">Niveau </label>
              <input type="text"  id='Niveau' class="form-control" formControlName="level" />
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label for="crmId">CRM id </label>
              <input type="text"  id='crmId' class="form-control" formControlName="crmId" />
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label for="plannerId">Planner id </label>
              <input type="text"  id='plannerId' class="form-control" formControlName="plannerId" />
            </div>
          </div>


        </div>

        <div class="row">
          <div class="col-md-12">
            <input type="checkbox" formControlName="expert" id="expert" class="form-check-input" />
            <label for="expert" class="check form-check-label" style="margin-left: 6px"> Accès au mode expert</label>
          </div>
        </div>

        <br/>
        <div class="d-flex">
          <div class="mr-auto p-2"></div>


          <div class="p-2"><button  class="btn btn-primary pull-right">{{traductionsKeysEnum.UPDATE| translate}}</button></div>
        </div>
      </form>
    </div>
  </div>
</div>
